import { resetCDNCache } from '../api/cdn';
import { StorefrontOptions, CRUDRequestOptions, GetRequestOptions, InitOptions } from '../types';
import { setOptions } from './options';
import { request } from './request';

/**
 * @internal
 * @deprecated will be removed in next version
 */
export const api = {
  get<T>(url: string, requestOptions?: GetRequestOptions): Promise<T> {
    return request<T>('get', url, requestOptions);
  },
  post<T>(url: string, requestOptions?: CRUDRequestOptions): Promise<T> {
    return request<T>('post', url, requestOptions);
  },
  put<T>(url: string, requestOptions?: CRUDRequestOptions): Promise<T> {
    return request<T>('put', url, requestOptions);
  },
  delete<T>(url: string, requestOptions?: CRUDRequestOptions): Promise<T> {
    return request<T>('delete', url, requestOptions);
  },
};

/**
 * Uses passed in storeIdentifier, but if it's not passed in will try to infer it.
 * Currently it will only infer if we are in the context of a Shopify store. This will not infer headless or hosted yet.
 */
function getStoreIdentifier(storeIdentifier?: string): string {
  if (storeIdentifier) {
    return storeIdentifier;
  }

  // Infer's when on Shopify store (non headless)
  if (window?.Shopify?.shop) {
    return window.Shopify.shop;
  }

  // Domain exists on hosted themes. If it doesn't for some reason, get the subdomain and create the identifier
  let domain = window?.domain;
  if (!domain) {
    const subdomain = location?.href
      .match(/(?:http[s]*:\/\/)*(.*?)\.(?=admin\.rechargeapps\.com)/i)?.[1]
      .replace(/-sp$/, '');
    if (subdomain) {
      domain = `${subdomain}.myshopify.com`;
    }
  }

  // Infer's when on Recharge hosted
  if (domain) {
    return domain;
  }

  throw new Error(`No storeIdentifier was passed into init.`);
}

export function initRecharge(opt: InitOptions = {}) {
  const hiddenOpts = opt as StorefrontOptions;
  const { storefrontAccessToken } = opt;
  if (storefrontAccessToken && !storefrontAccessToken.startsWith('strfnt')) {
    throw new Error(
      'Incorrect storefront access token used. See https://storefront.rechargepayments.com/client/docs/getting_started/package_setup/#initialization-- for more information.'
    );
  }
  setOptions({
    storeIdentifier: getStoreIdentifier(opt.storeIdentifier),
    loginRetryFn: opt.loginRetryFn,
    __unstable_twoFactorRetryFn: opt.__unstable_twoFactorRetryFn,
    storefrontAccessToken,
    appName: opt.appName,
    appVersion: opt.appVersion,
    environment: hiddenOpts.environment ? hiddenOpts.environment : 'prod',
    environmentUri: hiddenOpts.environmentUri,
    customerHash: hiddenOpts.customerHash,
  });

  // When init is called again, reset the cache to make sure we don't have the old cache around
  resetCDNCache();
}
